import type { ComponentProps } from "react"

export default function PropertyPublic(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14.6667 1.33325V8.66658H6.66667V11.3333H25.3333V8.66658H17.3333V5.33325H21.3333V1.33325H14.6667ZM0 15.9999H6.66667V31.9999H0V15.9999ZM25.3333 15.9999H32V31.9999H25.3333V15.9999ZM23.3333 20.9999V13.3333H8.66667V20.9999H23.3333ZM17.6667 15.9999H19.6667V18.6666H17.6667V15.9999ZM12.3333 15.9999H14.3333V18.6666H12.3333V15.9999ZM8.66667 22.9999V31.9999H23.3333V22.9999H8.66667ZM14.3333 27.9999H12.3333V25.3333H14.3333V27.9999ZM19.6667 27.9999H17.6667V25.3333H19.6667V27.9999Z"
        fill={fill}
      />
    </svg>
  )
}
